import CompareAtPrice from './CompareAtPrice';
import SalePrice from './SalePrice';

const Price = (props) => {
  const { variant, settings } = props;

  return (
    <div className="c7-product__variant__price">
      <CompareAtPrice variant={variant} settings={settings} />
      <SalePrice variant={variant} settings={settings} />
    </div>
  );
};

export default Price;
